import { render, staticRenderFns } from "./DowntimeReasonsView.vue?vue&type=template&id=7182911a&scoped=true"
import script from "./DowntimeReasonsView.vue?vue&type=script&lang=js"
export * from "./DowntimeReasonsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182911a",
  null
  
)

export default component.exports